import { Component, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, UntypedFormBuilder, Validators } from '@angular/forms';
import { injectStripe, StripePaymentElementComponent } from 'ngx-stripe';
import { StripeElementsOptions, StripePaymentElementOptions } from '@stripe/stripe-js';
import { environment } from 'src/environments/environment';
import { UsersService } from 'src/app/services/users.service';
import { BehaviorSubject, timeout, Observable, timer, finalize } from 'rxjs';
import { Router } from '@angular/router';
import { CoreService } from 'src/app/services/core.service';
import { CookieService } from 'ngx-cookie-service';
import { LoaderService } from 'src/app/services/loader.service';
import { ApiService } from 'src/app/services/api.service';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CartStorage } from 'src/app/storage/cart';
import { ResumeStorage } from 'src/app/storage/resume';
import { retry } from 'rxjs/operators';
import { CheckoutStockService } from 'src/app/services/checkout-stock.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})

export class PaymentComponent implements OnInit {
  private readonly purchaseStates = {
    INITIALIZING: 'INITIALIZING',
    APARTADO_CREATED: 'APARTADO_CREATED',
    PAYMENT_PENDING: 'PAYMENT_PENDING',
    PAYMENT_SUCCEEDED: 'PAYMENT_SUCCEEDED',
    CONFIRMING_SALE: 'CONFIRMING_SALE',
    COMPLETED: 'COMPLETED',
    CANCELLING: 'CANCELLING',
    CANCELLED: 'CANCELLED',
    VERIFICATION_PENDING: 'VERIFICATION_PENDING'
  } as const;

  @ViewChild(StripePaymentElementComponent)
  paymentElement!: StripePaymentElementComponent;
  paymentElementForm!: any
  paymentType: string = ""
  productsCart: any[] = []
  costoEnvio = 0
  cookieBranch: any = {}
  idStandby: string = ""
  dataProductsAll: any = []
  isPaying: boolean = false

  elementsOptions: StripeElementsOptions = {
    locale: 'es',
    appearance: {
      theme: 'flat'
    }
  };

  paymentElementOptions: StripePaymentElementOptions = {
    layout: {
      type: 'tabs',
      defaultCollapsed: false,
      radios: false,
      spacedAccordionItems: false
    }
  };

  userData: any = {}
  requestBodyNina: any = {}
  paymentIntent: string = ""
  total = 0

  stripe = injectStripe(environment.stripe_apikey);
  private _value = new BehaviorSubject<boolean>(false);
  public paying = this._value.asObservable();

  timeLeft: number = 180;
  timer: any;
  private countdownEndsAt: number = 0;

  private paymentSucceeded = false;
  private cancellationInProgress = false;
  private apartadoConfirmationInProgress = false;
  private apartadoConfirmed = false;
  private paymentIntentCreationInProgress = false;
  private stripeConfirmationInProgress = false;
  private paymentInfoInProgress = false;
  private orderCreationInProgress = false;
  private saleConfirmationInProgress = false;
  private paymentVerificationPending = false;
  private purchaseState: string = this.purchaseStates.INITIALIZING;
  private returningToCartForStock = false;
  private checkoutStoppedForStock = false;

  vehicleType: string = ""
  weight: number = 0
  userPointsData: any = null
  pointsToUse: number = 0
  paymentIntentCreated: boolean = false
  stripeReady: boolean = false
  freePurchase: boolean = false
  usePoints: boolean = false

  constructor(private loaderService: LoaderService, public cookies: CookieService, public apiServices: ApiService, public apiUsersServices: UsersService, public formBuilder: FormBuilder, private coreService: CoreService, private router: Router, private cookieService: CookieService, private gtm: GoogleTagManagerService, public dialog: MatDialog, private checkoutStockService: CheckoutStockService) {
    this.userData = JSON.parse(this.cookieService.get("CartUD"))
    const data = localStorage.getItem('Data');

    if (!data) {
      console.error('[PAYMENT] No existe Data en localStorage');
      this.router.navigate(['/cart']);
      return;
    }

    this.requestBodyNina = JSON.parse(data);
    this.productsCart = ResumeStorage.getResume().products
    this.total = this.requestBodyNina.importe
    this.createForm()
    if (this.cookies.check("Branch")) {
      this.cookieBranch = JSON.parse(this.cookies.get("Branch"))
    }
    this.gtm.pushTag({ event: 'begin_checkout' });
    this.getPuntosPorUsuario()
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    this.cancelApartado()
  }

  @HostListener('document:visibilitychange')
  onVisibilityChange(): void {
    if (!document.hidden && this.countdownEndsAt > 0) {
      this.updateCountdown();
    }
  }

  ngOnInit(): void {
    this.startCountdown()
  }


  createPaymentIntent() {
    this.logCheckoutTrace('Inicio de createPaymentIntent');
    if (this.checkoutStoppedForStock || this.paymentIntentCreated || this.paymentIntentCreationInProgress) {
      return;
    }

    this.paymentIntentCreationInProgress = true;
    this.requestWithRetry(
      this.apiUsersServices.createPaymentIntent({
        amount: ((this.total + this.costoEnvio) - this.pointsToUse) * 100,
        meta: {
          orden: this.requestBodyNina.idVenta,
          user_id: this.requestBodyNina.idCliente,
          puntos: this.pointsToUse
        }
      }))
      .subscribe({
        next: (pi: any) => {
          this.logCheckoutTrace('Respuesta de createPaymentIntent');
          if (this.checkoutStoppedForStock) {
            return;
          }
          this.paymentIntentCreationInProgress = false;
          const clientSecret = pi?.paymentIntent;
          if (pi.status === true && typeof clientSecret === 'string' && clientSecret.includes('_secret_')) {
            this.paymentIntentCreated = true;
            this.stripeReady = false;
            this.elementsOptions = {
              ...this.elementsOptions,
              clientSecret
            } as unknown as StripeElementsOptions;
            this.isPaying = pi.status;
            this.purchaseState = this.purchaseStates.PAYMENT_PENDING;
          } else {
            console.error('Respuesta inválida al generar el pago; se esperaba un PaymentIntent client secret:', pi);
            this.coreService.emitSubjet.next({
              type: 'Snackbar',
              payload: { text: pi?.message || 'No fue posible confirmar la creación del pago. El pedido está pendiente de verificación.' }
            });
            this.markPaymentVerificationPending(pi);
          }
        },
        error: (err) => {
          console.error('[PAYMENT] Error de createPaymentIntent:', err);
          this.paymentIntentCreationInProgress = false;

          if (this.paymentSucceeded || this.paymentVerificationPending) {
            this.purchaseState = this.purchaseStates.VERIFICATION_PENDING;
            this.coreService.emitSubjet.next({
              type: 'Snackbar',
              payload: {
                text: 'No fue posible verificar el estado del pago. Tu pago está pendiente de verificación; no intentes pagarlo nuevamente.'
              }
            });
            return;
          }

          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: {
              text: 'No fue posible iniciar el pago. Regresando al carrito...'
            }
          });

          setTimeout(() => {
            this.navigateToCartIfPayment();
          }, 2000);
        },
      });
  }


  startCountdown(): void {
    clearInterval(this.timer);

    this.countdownEndsAt = Date.now() + this.timeLeft * 1000;

    this.updateCountdown();

    this.timer = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  private updateCountdown(): void {
    if (this.paymentSucceeded || this.cancellationInProgress || this.isPurchaseProtectedFromCancellation()) {
      return;
    }

    this.timeLeft = Math.max(
      0,
      Math.ceil((this.countdownEndsAt - Date.now()) / 1000)
    );

    if (this.timeLeft <= 0) {
      clearInterval(this.timer);
      this.timer = null;
      this.countdownEndsAt = 0;
      this.cancelApartado(true);
    }
  }

  ngOnDestroy(): void {
    this.logCheckoutTrace('Ejecución de ngOnDestroy');
    clearInterval(this.timer);
    this.timer = null;

    if (
      !this.returningToCartForStock &&
      !this.checkoutStoppedForStock &&
      !this.paymentSucceeded &&
      !this.cancellationInProgress &&
      this.purchaseState !== this.purchaseStates.CANCELLED
    ) {
      this.cancelApartado();
    }
  }

  getFormattedTime(): string {
    const minutes = Math.floor(this.timeLeft / 60);
    const seconds = this.timeLeft % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  createForm() {
    this.paymentElementForm = this.formBuilder.group({
      name: [`${this.userData.names} ${this.userData.last_name} ${this.userData.last_name2}`, [Validators.required]],
      email: [this.userData.email, [Validators.required]],
      address: [this.requestBodyNina.Direccion],
      zipcode: [this.userData.zip_code],
      city: [this.userData.municipality],
      amount: [(this.requestBodyNina.importe * 100), [Validators.required, Validators.pattern(/\d+/)]]
    });
    this.paymentElementForm.controls['name'].disable();
    this.paymentElementForm.controls['email'].disable();
    this.paymentElementForm.controls['address'].disable();
    this.paymentElementForm.controls['zipcode'].disable();
    this.paymentElementForm.controls['city'].disable();
  }

  pay() {
    if (this.checkoutStoppedForStock) {
      return;
    }
    if (this.stripeConfirmationInProgress || this.paymentInfoInProgress || this.orderCreationInProgress || this.saleConfirmationInProgress) {
      return;
    }

    this.gtm.pushTag({ event: 'add_payment_info' });
    if (this.freePurchase) {
      if (this.requestBodyNina.EntregaADomicilio) {
        this.createOrderInStandByInc()
      }
      else {
        this.sendPagoToNina()
      }
    }
    else {
      if (!this.paymentIntentCreated || !this.stripeReady || !this.paymentElement) {
        return;
      }

      this.stripeConfirmationInProgress = true;
      this.loaderService.show();
      this.stripe.confirmPayment({
        elements: this.paymentElement.elements,
        confirmParams: {
          payment_method_data: {
            billing_details: {
              name: `${this.userData.names} ${this.userData.last_name} ${this.userData.last_name2}`,
              email: this.userData.email,
              address: {
                line1: this.requestBodyNina.Direccion,
                postal_code: this.userData.zip_code + "",
                city: this.userData.municipality
              }
            }
          }
        },
        redirect: 'if_required'
      })
        .pipe(
          timeout(180000) // 3 minutos
        )
        .subscribe({
          next: (result) => {
            this.stripeConfirmationInProgress = false;

            if (result.error) {

              this.loaderService.hide();

              this.coreService.emitSubjet.next({
                type: 'Snackbar',
                payload: {
                  text: result.error.message
                }
              });

              return;
            }

            if (result.paymentIntent?.status === 'succeeded') {
              this.paymentSucceeded = true;
              this.purchaseState = this.purchaseStates.PAYMENT_SUCCEEDED;

              clearInterval(this.timer);
              this.timer = null;
              this.countdownEndsAt = 0;

              this.paymentIntent = result.paymentIntent.id;

              setTimeout(() => {
                this.getPaymentInfo();
              }, 3000);
            } else {
              this.loaderService.hide();
              console.error('Stripe no devolvió un PaymentIntent confirmado:', result);
              this.coreService.emitSubjet.next({
                type: 'Snackbar',
                payload: { text: 'No fue posible confirmar el estado del pago. Intenta de nuevo más tarde.' }
              });
            }
          },

          error: (err) => {
            this.stripeConfirmationInProgress = false;

            this.loaderService.hide();

            if (err.name === 'TimeoutError') {
              this.markPaymentVerificationPending(err);

              this.coreService.emitSubjet.next({
                type: 'Snackbar',
                payload: {
                  text: 'La confirmación del pago está tardando más de lo esperado. Estamos verificando el estado del cargo.'
                }
              });
              this.getPaymentInfo(true);

            }
            else {
              this.markPaymentVerificationPending(err);
              this.getPaymentInfo(true);

            }
          }
        });
    }
  }

  onStripeReady(): void {
    this.stripeReady = true;
  }

  onStripeLoadError(error: any): void {
    this.stripeReady = false;
    console.error('Stripe Payment Element no pudo inicializarse:', error);
    this.coreService.emitSubjet.next({
      type: 'Snackbar',
      payload: { text: 'No fue posible cargar el formulario de pago. Intenta nuevamente más tarde.' }
    });
  }

  getPaymentInfo(verificationOnly: boolean = false) {
    if (this.paymentInfoInProgress || this.orderCreationInProgress || this.saleConfirmationInProgress) {
      return;
    }

    this.paymentInfoInProgress = true;
    this.loaderService.show()
    let dataPayment = { orden: this.requestBodyNina.idVenta }
    this.requestWithRetry(this.apiUsersServices.getPaymentInfo(dataPayment)).pipe(
      finalize(() => {
        this.paymentInfoInProgress = false;
        this.loaderService.hide();
      })
    ).subscribe({
      next: (value) => {
        if (value.status) {
          this.paymentVerificationPending = false;
          this.paymentType = value.data.tipo === 'credit' ? 'C' : value.data.tipo === 'debit' ? 'D' : value.data.tipo === 'link' ? 'L' : '';
          if (this.requestBodyNina.EntregaADomicilio) {
            this.createOrderInStandByInc()
          }
          else {
            this.sendPagoToNina()
          }
        }
        else {
          console.error(value.data.message)
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: verificationOnly || this.paymentVerificationPending ? 'El pago está pendiente de verificación. No intentes pagarlo nuevamente.' : value.data.message } });
        }
      },
      error: (err) => {
        console.error("Error de Pago")
        console.error(err)
        if (this.paymentSucceeded || this.paymentVerificationPending) {
          this.purchaseState = this.purchaseStates.VERIFICATION_PENDING;
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: 'No fue posible verificar el estado del pago. Tu pago está pendiente de verificación; no intentes pagarlo nuevamente.' } });
          return;
        }
        this.handlePaymentRequestError()
      },
    })
  }

  newCostShipping() {
    let cookieMapAddress = JSON.parse(this.cookies.get("MyAddress"))
    // console.log("newCostShipping - cookieMapAddress", cookieMapAddress)
    // console.log("newCostShipping - this.cookieBranch", this.cookieBranch)
    let dataFare = {
      weight: this.weight,
      vehicleType: this.vehicleType,
      coordStart: {
        latitude: parseFloat(this.cookieBranch.latitud),
        longitude: parseFloat(this.cookieBranch.longitud)
      },
      coordEnd: {
        latitude: cookieMapAddress.geometry.location.lat,
        longitude: cookieMapAddress.geometry.location.lng
      }
    }
    this.requestWithRetry(this.apiUsersServices.getFare(dataFare)).subscribe({
      next: (value) => {
        this.costoEnvio = Math.ceil(value.data.precio)
        this.total = Math.ceil(parseFloat(this.total.toFixed(2)))
        this.confirmarApartado()
      },
      error: (err) => {
        console.error("Error al obtener estimacion")
        console.error(err)
        this.handlePaymentRequestError()
      },
    })
  }

  sendPagoToNina() {
    if (this.saleConfirmationInProgress) {
      return;
    }

    this.saleConfirmationInProgress = true;
    this.purchaseState = this.purchaseStates.CONFIRMING_SALE;
    this.loaderService.show()
    let dataConfirm = {
      idVenta: this.requestBodyNina.idVenta,
      importeTotal: this.total + this.costoEnvio,
      importeAPagarConTarjeta: (this.total + this.costoEnvio) - this.pointsToUse,
      Referencia: this.paymentIntent,
      formaDePago: this.paymentType,
      orderIdStandBy: this.idStandby,
      utilizarPuntos: this.pointsToUse > 0,
      puntosACanjear: this.pointsToUse
    }
    this.requestWithRetry(
      this.apiServices.confirmaVentaConEnvioYPuntos(dataConfirm)).subscribe({
        next: (value) => {
          if (value[0].resultado === "ERROR") {
            this.markPaymentVerificationPending(value);
            alert("El cargo se realizó de manera exitosa pero ocurrió un error al confirmar tu pedido. Por favor comunicate al teléfono 8715351045 con la Lic. Sofia López Pimentel para resolver el problema. Código de venta: " + this.requestBodyNina.idVenta)
            this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "El cargo se realizó de manera exitosa pero ocurrió un error al confirmar tu pedido. Por favor comunicate al teléfono 8715351045 con la Lic. Sofia López Pimentel para resolver el problema. Código de venta: " + this.requestBodyNina.idVenta } });

          }
          else if (value[0].resultado === "OK") {
            this.completePurchase();
          }
          else {
            this.markPaymentVerificationPending(value);

            this.coreService.emitSubjet.next({
              type: 'Snackbar',
              payload: {
                text: 'El pago fue realizado, pero no fue posible confirmar el pedido. Está pendiente de verificación.'
              }
            });
          }
          this.loaderService.hide()
        },
        error: (err) => {
          this.markPaymentVerificationPending(err);
          alert("El cargo se realizó de manera exitosa pero ocurrió un error al confirmar tu pedido. Por favor comunicate al teléfono 8715351045 con la Lic. Sofia López Pimentel para resolver el problema. Código de venta: " + this.requestBodyNina.idVenta)
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "El cargo se realizó de manera exitosa pero ocurrió un error al confirmar tu pedido. Por favor comunicate al teléfono 8715351045 con la Lic. Sofia López Pimentel para resolver el problema. Código de venta: " + this.requestBodyNina.idVenta } });
          console.error(err)
          this.loaderService.hide()
        },
      })
  }

  private navigateToCartIfPayment(): void {
    if (this.router.url.startsWith('/payment')) {
      this.router.navigate(['/cart']);
    }
  }

  private finishCancellation(timeExpired: boolean): void {
    if (this.paymentSucceeded || this.isPurchaseProtectedFromCancellation()) {
      return;
    }

    this.purchaseState = this.purchaseStates.CANCELLED;
    this.cancellationInProgress = false;

    clearInterval(this.timer);
    this.timer = null;
    this.countdownEndsAt = 0;

    this.clearCancelledCheckoutData();

    this.coreService.emitSubjet.next({
      type: 'Cart',
      payload: null
    });

    this.coreService.emitSubjet.next({
      type: 'Snackbar',
      payload: {
        text: timeExpired
          ? 'El tiempo para completar tu compra ha terminado. Tu apartado será liberado automáticamente.'
          : 'Por favor reintenta desde el carrito.'
      }
    });

    this.navigateToCartIfPayment();
  }

  cancelApartado(timeExpired: boolean = false) {
    if (this.purchaseState === this.purchaseStates.CANCELLED) {
      return;
    }

    this.logCheckoutTrace('Ejecución de cancelApartado');
    if (this.returningToCartForStock || this.checkoutStoppedForStock) {
      return;
    }
    if (this.cancellationInProgress || this.isPurchaseProtectedFromCancellation()) {
      return;
    }

    if (this.purchaseState === this.purchaseStates.INITIALIZING) {
      this.clearCancelledCheckoutData();
      this.navigateToCartIfPayment();
      return;
    }

    this.cancellationInProgress = true;
    this.purchaseState = this.purchaseStates.CANCELLING;

    clearInterval(this.timer);
    this.timer = null;
    this.countdownEndsAt = 0;

    const dataCancel = {
      idVenta: this.requestBodyNina.idVenta ?? 0
    };

    if (dataCancel.idVenta === 0) {
      this.finishCancellation(timeExpired);
      return;
    }
    else {
      this.loaderService.show()
      this.apiServices.solicitaCancelacionApartado(dataCancel)
        .pipe(
          timeout(15000),
          finalize(() => this.loaderService.hide())
        )
        .subscribe({
          next: (value) => {
            console.warn('Respuesta de solicitud de cancelación:', value);

            if (value[0]?.resultado === "ERROR") {
              console.error('El backend no confirmó la cancelación:', value);
            }

            this.finishCancellation(timeExpired);
          },

          error: (err) => {
            console.error(
              'No se recibió confirmación de cancelación. Se asumirá la liberación automática:',
              err
            );

            this.finishCancellation(timeExpired);
          }
        })
    }
  }

  createOrderInStandByInc() {
    if (this.orderCreationInProgress || this.saleConfirmationInProgress || this.idStandby) {
      return;
    }

    this.orderCreationInProgress = true;
    this.loaderService.show()
    let cookieMapAddress = JSON.parse(this.cookies.get("MyAddress"))
    let comment = this.userData.references ?? "Referencias no proporcionadas" + " - " + "Nina Web - ID: " + this.requestBodyNina.idVenta + cookieMapAddress.formatted_address
    // console.log("createOrderInStandByInc - comment", comment)
    // console.log("createOrderInStandByInc - cookieMapAddress", cookieMapAddress)
    // console.log("createOrderInStandByInc - this.cookieBranch", this.cookieBranch)
    let orderStandBy = {
      weight: 1,
      vehicleType: this.requestBodyNina.enviarEnAutomovil ? "SEDAN" : "MOTORCYCLE",
      coordStart: {
        latitude: parseFloat(this.cookieBranch.latitud),
        longitude: parseFloat(this.cookieBranch.longitud),
        address: this.cookieBranch.direccion,
        type: "PICKUP",
        whoReceives: "Pastelería Nina",
        whoReceivesPhone: this.cookieBranch.telefono,
        po: parseInt(this.cookieBranch.codigo_postal),
        comments: "Nina Web - ID Venta: " + this.requestBodyNina.idVenta,
        items: this.productsCart.map(prod => {
          return {
            product: this.getProductName(prod),
            quantity: prod.qty,
            type: "PRODUCT"
          }
        })
      },
      coordEnd: {
        latitude: cookieMapAddress.geometry.location.lat,
        longitude: cookieMapAddress.geometry.location.lng,
        address: cookieMapAddress.formatted_address,
        type: "DROPOFF",
        whoReceives: `${this.userData.names} - Rec.: ${this.userData.receive} / ${this.userData.phone} - ID: ${this.requestBodyNina.idVenta}`,
        whoReceivesPhone: this.userData.accountPhone,
        po: this.userData.zip_code + "",
        comments: comment,
        items: this.productsCart.map(prod => {
          return {
            product: this.getProductName(prod),
            quantity: prod.qty,
            type: "PRODUCT"
          }
        })
      }
    }

    // console.log("createOrderInStandByInc - orderStandBy", orderStandBy)
    this.requestWithRetry(
      this.apiUsersServices.createOrder(orderStandBy)).subscribe({
        next: (value) => {
          // console.log(value)
          this.idStandby = value.data.id
          this.orderCreationInProgress = false;
          this.loaderService.hide()
          this.sendPagoToNina()
        },
        error: (err) => {
          console.error("Error creating Order in StandBy:", err);
          this.orderCreationInProgress = false;
          this.loaderService.hide();
          this.purchaseState = this.purchaseStates.VERIFICATION_PENDING;
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: {
              text: 'No fue posible confirmar la creación del envío. El pago está pendiente de verificación.'
            }
          });
        },
      })
  }

  confirmarApartado() {
    this.logCheckoutTrace('Inicio de confirmarApartado');
    if (this.checkoutStoppedForStock || this.apartadoConfirmationInProgress || this.apartadoConfirmed) {
      return;
    }

    this.apartadoConfirmationInProgress = true;
    this.loaderService.show()
    if (this.usePoints) {
      let excessPoints = this.pointsToUse - (this.total + this.costoEnvio)

      if (excessPoints >= 0) {
        this.freePurchase = true
        this.pointsToUse = this.total + this.costoEnvio
      }
    }
    this.requestBodyNina.importeEnvioADomicilio = this.costoEnvio
    this.requestBodyNina.importe = this.total
    this.requestWithRetry(
      this.apiServices.solicitaApartadoConEnvioPromo(this.requestBodyNina)).subscribe({
        next: (value) => {
          this.logCheckoutTrace('Respuesta de confirmarApartado', value?.idVenta);
          if (this.checkoutStoppedForStock) {
            return;
          }
          this.apartadoConfirmationInProgress = false;
          if (value.resultado === "ERROR") {
            if (value.error === 7) {
              this.logCheckoutTrace('Detección de error 7', value?.idVenta);
              this.handleInsufficientStock(value);
              return;
            }
            else if (value.error === 8) {
              // console.log("Entro error 8")
              this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: value.mensaje } });
              this.router.navigate(['home']);
            }
            else {
              this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: value.mensaje } });
              this.router.navigate(['home']);
            }
          }
          else if (value.idVenta === 0) {
            clearInterval(this.timer);
            this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: value.mensaje } });
            this.cancelApartado()
          }
          else if (value.resultado === "OK") {
            this.apartadoConfirmed = true;
            this.purchaseState = this.purchaseStates.APARTADO_CREATED;
            clearInterval(this.timer);

            if (value.idVenta !== 0) {
              this.timeLeft = 600;

              this.requestBodyNina.idVenta = value.idVenta;
              this.requestBodyNina.enviarEnAutomovil = value.enviarEnAutomovil;

              if (this.freePurchase) {
                // No se requiere Payment Intent para una compra gratuita.
                this.isPaying = true;
              } else {
                this.startCountdown();
                this.createPaymentIntent();
              }
            } else {
              this.coreService.emitSubjet.next({
                type: 'Snackbar',
                payload: { text: value.mensaje }
              });

              this.cancelApartado();
            }
          }
          this.loaderService.hide()
        },
        error: (err) => {
          this.apartadoConfirmationInProgress = false;
          console.error('No fue posible confirmar el apartado; su estado es incierto.', err);

          this.purchaseState = this.purchaseStates.VERIFICATION_PENDING;

          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: {
              text: 'No fue posible confirmar el apartado. Su estado está pendiente de verificación.'
            }
          });

          this.loaderService.hide();
        }
      })
  }

  changeQty(action: string, product: any) {
    const itemIndex = this.productsCart.findIndex(
      (p: any) => p.idProducto === product.idProducto
    );

    if (itemIndex === -1) return;

    const item = this.productsCart[itemIndex];

    switch (action) {
      case "sumar":
        if (item.qty < product.existencia) {
          item.qty++;
        } else {
          this.coreService.emitSubjet.next({
            type: "Snackbar",
            payload: { text: "No hay suficiente existencia de este producto :(" }
          });
        }
        break;

      case "restar":
        if (item.qty > 1) {
          item.qty--;
        }
        break;

      case "remover":
        this.productsCart.splice(itemIndex, 1);
        break;
    }

    if (this.productsCart.length > 0) {
      this.productsCart = this.productsCart.map((cartItem: any) => {
        const productData = this.dataProductsAll.find(
          (p: any) => p.idProducto === cartItem.idProducto
        );
        return { ...productData, ...cartItem };
      });
      this.calculateTotal();

      CartStorage.saveCart(this.productsCart)

    }
    else {
      CartStorage.clear()
    }

    this.coreService.emitSubjet.next({ type: "Cart", payload: null });
    this.navigateToCartIfPayment();
  }


  calculateTotal() {
    this.total = 0;
    this.productsCart.forEach((element: any) => {
      this.total = this.total + (element.precioVenta * element.qty)
    });
  }

  getProducts() {
    this.loaderService.show()
    let data = { token: this.cookies.get('Token') }
    this.apiServices.getProductos(data).subscribe({
      next: (value) => {
        this.dataProductsAll = value;
        if (this.productsCart.length > 0) {
          this.productsCart = this.productsCart.map((elementCart: any) => ({
            ...(this.dataProductsAll.find((element: any) => element.idProducto === elementCart.idProducto) || {}),
            ...elementCart
          }));
        }
        else {
          if (this.cookies.check("Branch")) {
            this.cookies.delete("Branch")
            this.cookies.delete("Shippeable")
          }
        }
        this.calculateTotal()
      },
      error: (err) => {
        // console.log(err)
        this.loaderService.hide()
      }
    })
  }

  getVehicle() {
    let data: any = {
      listaDeProductos: this.productsCart.map(prod => {
        return {
          idProducto: prod.idProducto,
          cantidad: prod.qty,
          precio: prod.precioVenta
        }
      })
    }
    this.requestWithRetry(this.apiServices.determinaTipoDeVehiculo(data)).subscribe({
      next: (value) => {
        if (value[0].resultado === "OK") {
          value[0].enviarEnAutomovil ? this.vehicleType = "SEDAN" : this.vehicleType = "MOTORCYCLE"
          this.weight = value[0].pesoEnKgs
          this.newCostShipping()
        }
        else {
          this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Hubo un error al determinar el tipo de vehículo para la entrega" } });
        }
      },
      error: (err) => {
        console.error('Error al determinar el tipo de vehículo:', err);
        this.handlePaymentRequestError()
      }
    })
  }

  getPuntosPorUsuario() {
    let data = { token: this.cookies.get('Token'), idCliente: this.requestBodyNina.idCliente }
    this.requestWithRetry(this.apiServices.getPuntosPorUsuario(data)).subscribe({
      next: (value) => {
        if (value.length > 0) {
          this.userPointsData = value[0]
          if (this.userPointsData.puntos <= 0) {
            if (this.requestBodyNina.EntregaADomicilio) {
              this.getVehicle()
            }
            else {
              this.confirmarApartado()
            }
          }
          else {
            this.openDialogPoints()
          }
          this.loaderService.hide()
        }
        else {
          // this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: "Hubo un error al procesar tu solicitud" } });
          console.error("No se pudieron recuperar los puntos")
        }
        this.loaderService.hide()
      },
      error: (err) => {
        console.error("Puntos no recuperados Error:")
        console.error(err)
        this.handlePaymentRequestError()
      },
    })
  }

  openDialogPoints(): void {
    const isMobile = window.innerWidth <= 768;
    const dialogRef = this.dialog.open(DialogAskPoints, {
      width: isMobile ? '92vw' : '430px',
      maxWidth: '95vw',
      height: 'auto',
      maxHeight: '90vh',
      backdropClass: 'nina-dialog-backdrop',
      data: this.userPointsData
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result?.usePoints) {
        this.usePoints = true;
        this.pointsToUse = this.userPointsData.puntos;
      }
      else {
        this.usePoints = false;
        this.pointsToUse = 0;
      }
      if (this.requestBodyNina.EntregaADomicilio) {
        this.getVehicle();
      }
      else {
        this.confirmarApartado();
      }
    });
  }

  private getProductName(prod: any): string {
    return (
      prod?.descripcionProducto?.trim() ||
      prod?.producto?.trim() ||
      prod?.nombre?.trim() ||
      prod?.productoAgrupador?.trim() ||
      'Producto sin nombre'
    );
  }

  private handleInsufficientStock(response: any): void {
    this.logCheckoutTrace('Entrada a handleInsufficientStock', response?.idVenta);
    // El backend confirma idVenta: 0; no existe apartado que cancelar.
    if (Number(response.idVenta) !== 0) {
      console.error('Respuesta de existencia con una venta asociada; no se cancelará de forma especulativa:', response);
      this.purchaseState = this.purchaseStates.VERIFICATION_PENDING;
      this.coreService.emitSubjet.next({
        type: 'Snackbar',
        payload: { text: 'No fue posible validar el estado del pedido. Está pendiente de verificación.' }
      });
      return;
    }

    const affectedIds = [...new Set(
      (response.productosSinExistencia || [])
        .map((product: any) => Number(product?.idProducto))
        .filter((id: number) => Number.isFinite(id))
    )];
    const cartProducts = CartStorage.getCart();
    const affectedProducts = affectedIds.map((idProducto) => {
      const currentProduct = this.productsCart.find((product: any) => Number(product.idProducto) === idProducto);
      const catalogProduct = this.dataProductsAll.find((product: any) => Number(product.idProducto) === idProducto);
      const storedProduct = cartProducts.find((product: any) => Number(product.idProducto) === idProducto);
      const product = { ...storedProduct, ...catalogProduct, ...currentProduct };

      const nombre = product?.descripcionProducto?.trim() || product?.producto?.trim() || product?.nombre?.trim() || product?.productoAgrupador?.trim() || `Producto #${idProducto}`;

      return {
        idProducto,
        nombre,
        presentacion: product?.porciones ? `${product.porciones} porciones` : '',
        cantidadSolicitada: product?.qty ?? 0,
        existencia: product?.existencia,
        precio: product?.precioPromocionPorProducto ?? product?.precioPromocion ?? product?.precioNormal ?? product?.precioVenta,
        urlFoto: product?.urlFoto || ''
      };
    });

    clearInterval(this.timer);
    this.timer = null;
    this.countdownEndsAt = 0;
    this.timeLeft = 0;
    this.returningToCartForStock = true;
    this.checkoutStoppedForStock = true;
    this.freePurchase = false;
    this.isPaying = false;
    this.paymentIntentCreated = false;
    this.stripeReady = false;
    this.apartadoConfirmed = false;
    this.purchaseState = this.purchaseStates.INITIALIZING;

    // Se conserva el carrito completo: el usuario decide qué cantidad ajustar o qué producto eliminar.
    CartStorage.saveCart(this.productsCart);
    this.clearCancelledCheckoutData();
    this.coreService.emitSubjet.next({ type: 'Cart', payload: null });
    this.coreService.emitSubjet.next({
      type: 'Snackbar',
      payload: { text: 'Algunos productos no tienen existencia suficiente. Revisa tu carrito para continuar.' }
    });

    this.checkoutStockService.setPendingProducts(affectedProducts);
    this.loaderService.hide();
    this.router.navigate(['/cart']);
  }

  private logCheckoutTrace(event: string, idVenta: any = this.requestBodyNina?.idVenta): void {
    console.info(`[Checkout] ${event}`, { purchaseState: this.purchaseState, idVenta });
  }

  private isPurchaseProtectedFromCancellation(): boolean {
    return [
      this.purchaseStates.PAYMENT_SUCCEEDED,
      this.purchaseStates.CONFIRMING_SALE,
      this.purchaseStates.COMPLETED,
      this.purchaseStates.VERIFICATION_PENDING
    ].includes(this.purchaseState as any);
  }

  private markPaymentVerificationPending(details: any): void {
    this.paymentVerificationPending = true;
    this.purchaseState = this.purchaseStates.VERIFICATION_PENDING;
    clearInterval(this.timer);
    this.timer = null;
    this.countdownEndsAt = 0;
    console.error('Pago o confirmación de venta pendiente de verificación:', details);
  }

  private clearCancelledCheckoutData(): void {
    localStorage.removeItem('Data');
    this.cookies.delete('CartUD');
  }

  private completePurchase(): void {
    this.paymentSucceeded = true;
    this.purchaseState = this.purchaseStates.COMPLETED;
    clearInterval(this.timer);
    this.timer = null;
    this.countdownEndsAt = 0;

    this.gtm.pushTag({ event: 'purchase' });
    this.coreService.emitSubjet.next({ type: 'Snackbar', payload: { text: 'Tu pedido se ha realizado exitosamente muchas gracias!' } });
    CartStorage.clear();
    localStorage.removeItem('Data');
    this.cookies.delete('CartUD');
    this.cookies.delete('MyAddress');
    this.cookies.delete('DataPromo');
    localStorage.removeItem('MyAddressSelected');

    // ResumeData queda disponible hasta que BaseComponent cierre el modal de resumen.
    const resumeSale = ResumeStorage.getResume();
    resumeSale.idVenta = this.requestBodyNina.idVenta;
    ResumeStorage.saveResume(resumeSale);
    this.coreService.emitSubjet.next({ type: 'Cart', payload: null });
    this.coreService.emitSubjet.next({ type: 'SaleResume', payload: null });
    this.router.navigate(['home']);
  }

  private requestWithRetry<T>(request: Observable<T>): Observable<T> {
    return request.pipe(
      timeout(15000),
      retry({
        count: 3,
        delay: (error, retryCount) => {
          console.warn(
            `Petición fallida. Reintento ${retryCount} de 3`,
            error
          );

          return timer(1000 * retryCount);
        }
      })
    );
  }

  private handlePaymentRequestError(error?: any): void {
    if (this.isPurchaseProtectedFromCancellation() || this.cancellationInProgress) {
      return;
    }

    this.loaderService.hide();

    const message =
      error?.error?.message ||
      error?.message ||
      'No fue posible completar el proceso después de varios intentos.';

    this.coreService.emitSubjet.next({
      type: 'Snackbar',
      payload: {
        text: `${message} Regresaremos al carrito.`
      }
    });

    this.cancelApartado();
  }
}

@Component({
  selector: 'dialog-ask-points',
  templateUrl: './dialog-ask-points.html',
  styleUrls: ['./dialog-ask-points.scss']
})

export class DialogAskPoints {
  userPointsData: any = null

  constructor(private loaderService: LoaderService, private coreService: CoreService, public dialogRef: MatDialogRef<DialogAskPoints>, @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog) {
    this.userPointsData = data
  }

  ngOnInit(): void {

  }

  dontUsePoints() {
    this.dialogRef.close({ usePoints: false });
  }

  confirmUsePoints() {
    this.dialogRef.close({ usePoints: true });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'dialog-insufficient-stock',
  templateUrl: './dialog-insufficient-stock.html',
  styleUrls: ['./dialog-insufficient-stock.scss']
})
export class DialogInsufficientStock {
  readonly defaultImage = 'assets/img/logo_nina_placeholder.jpg';

  constructor(
    public dialogRef: MatDialogRef<DialogInsufficientStock>,
    @Inject(MAT_DIALOG_DATA) public data: { products: any[] }
  ) { }

  reviewCart(): void {
    this.dialogRef.close();
  }
}
